export const compressFile = async (file, maxSizeMB = 1) => {
  // ✅ Only images can be compressed in browser
  if (!file.type.startsWith("image/")) {
    return file;
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = e => (img.src = e.target.result);
    reader.onerror = reject;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let width = img.width;
      let height = img.height;

      // Resize large images
      const MAX_DIMENSION = 1920;
      if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
        if (width > height) {
          height = height * (MAX_DIMENSION / width);
          width = MAX_DIMENSION;
        } else {
          width = width * (MAX_DIMENSION / height);
          height = MAX_DIMENSION;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      let quality = 0.8; // ⭐ 70–80% sweet spot

      const compress = () => {
        canvas.toBlob(
          blob => {
            if (!blob) return reject("Compression failed");

            if (blob.size <= maxSizeMB * 1024 * 1024 || quality <= 0.6) {
              resolve(
                new File([blob], file.name, {
                  type: file.type,
                  lastModified: Date.now(),
                })
              );
            } else {
              quality -= 0.05;
              compress();
            }
          },
          "image/jpeg", // forces better compression
          quality
        );
      };

      compress();
    };

    reader.readAsDataURL(file);
  });
};
